import React from "react";
import { CommandBarButton, IconButton, SelectionMode } from "@fluentui/react";
import DetailsTable from "../../../../Table/DetailsTable";
import { useFormikContext } from 'formik';

const AffinityCourseTable = ({
    content,
    selectedContent,
    setSelectedContent,
    loading,
    createOnClick,
    deleteOnClick,
    maxSelectable = 8,
    showAddContent,
}) => {
    const { setFieldValue } = useFormikContext();
    // Always work directly from sorted content prop
    const sortedItems = (content ?? []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    function move(from, to) {
        if (to < 0 || to >= sortedItems.length) return;
        const newItems = sortedItems.slice();
        const temp = newItems[from];
        newItems[from] = newItems[to];
        newItems[to] = temp;
        newItems.forEach((item, i) => item.order = i + 1);
        setFieldValue('courses', newItems);
    }

    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu content={item} deleteOnClick={deleteOnClick} setSelectedContent={setSelectedContent} />
            ),
        },
        {
            name: 'ID',
            fieldName: 'crsid',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Title',
            fieldName: 'title',
            minWidth: 250,
            maxWidth: 400,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Slug',
            fieldName: 'slug',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
        },
        {
            name: 'Order',
            fieldName: 'order',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            onRender: (item, idx, items) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span>{item.order}</span>
                    <IconButton iconProps={{ iconName: 'Up' }} disabled={idx === 0} onClick={() => move(idx, idx - 1)} />
                    <IconButton iconProps={{ iconName: 'Down' }} disabled={idx === items.length - 1} onClick={() => move(idx, idx + 1)} />
                </div>
            ),
        },
    ];

    // Only allow selection up to maxSelectable
    const selectionHook = (items) => {
        if (selectedContent.length < maxSelectable) {
            setSelectedContent(items && items[0] && items[0].crsid);
        }
    };

    return (
        <DetailsTable
            items={sortedItems}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            shouldUsePagination={false}
            detailsListProps={{ selectionMode: SelectionMode.none }}
            mainColumn={"title"}
            style={{
                position: "relative",
                height: "60vh",
                width: "70vw",
            }}
            CommandBar={
                !showAddContent && selectedContent.length < maxSelectable ? (
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Add Courses"
                        onClick={() => createOnClick()}
                    />
                ) : false
            }
            hideFilterField
            hideSelectionDetails
        />
    );
};

const moreIcon = { iconName: "More" };

const ContextualMenu = ({ content, setSelectedContent, deleteOnClick, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: "Remove",
                iconProps: { iconName: "Delete" },
                text: "Remove",
                onClick: () => {
                    setSelectedContent(content);
                    deleteOnClick(content);
                },
            },
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

export default AffinityCourseTable;
